import { Reveal, StaggerGroup, StaggerItem3D } from "@/components/anim/Reveal";
import Tilt3D from "@/components/anim/Tilt3D";
import { HE } from "@/lib/i18n";

const ITEMS_EN = [
  {
    quote:
      "I built this after watching local businesses lose customers to whoever ChatGPT happened to recommend. Run the test — see where you're invisible.",
    name: "Yanir", role: "Founder, dev4u",
  },
  {
    quote:
      "The test runs the exact prompts your customers type — like “best dentist near me” — across 6 AI engines, and shows exactly where you're missing.",
    name: "How it works", role: "6 AI engines · 0–100 score · fixes ranked by impact",
  },
];

const ITEMS_HE = [
  {
    quote:
      "בניתי את זה אחרי שראיתי עסקים מקומיים מאבדים לקוחות למי שיצא ל-ChatGPT להמליץ עליו. הבדיקה מריצה בדיוק את מה שהלקוחות שלכם מקלידים — 'אינסטלטור מומלץ בחולון' — על פני 6 מנועי AI, ומראה איפה אתם שקופים.",
    name: "יניר", role: "מייסד dev4u",
  },
  {
    quote:
      "6 מנועי AI · שאלות אמיתיות של לקוחות בתחום שלכם · ציון 0–100 · תיקונים מדורגים לפי השפעה",
    name: "איך זה עובד", role: "התהליך, שקוף לגמרי",
  },
];

const ITEMS = HE ? ITEMS_HE : ITEMS_EN;

export const Testimonials = () => (
  <section className="py-20 md:py-28 border-b-2 border-obsidian bg-[#F9F9F9]">
    <div className="av-container">
      <Reveal>
        <div className="flex items-center gap-3 mb-4">
          <div className="h-3 w-3 bg-conversion" />
          <span className="av-label text-obsidian">{HE ? "בלי סיפורים" : "Straight talk"}</span>
        </div>
        <h2 className="font-display text-3xl sm:text-4xl text-obsidian max-w-2xl">
          {HE ? "בלי ביקורות מומצאות. הנה בדיוק מה שתקבלו." : "Here's exactly what you get."}
        </h2>
      </Reveal>
      <StaggerGroup className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12" gap={0.12}>
        {ITEMS.map((t) => (
          <StaggerItem3D key={t.name}>
            <Tilt3D className="h-full">
              <div className="av-card av-card-hover p-6 flex flex-col h-full" style={{ transformStyle: "preserve-3d" }}>
                <p className="text-lg text-obsidian leading-relaxed flex-1" style={{ transform: "translateZ(30px)" }}>“{t.quote}”</p>
                <div className="flex items-center gap-3 mt-6 pt-6 border-t-2 border-[rgba(10,10,10,0.08)]">
                  <div>
                    <div className="font-heading font-bold text-obsidian">{t.name}</div>
                    <div className="font-data text-xs text-neutral-500 uppercase tracking-wide">{t.role}</div>
                  </div>
                </div>
              </div>
            </Tilt3D>
          </StaggerItem3D>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

export default Testimonials;
